import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'

const PrivateRoutes = () => {
  // const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  // const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  // const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  // const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  // const GiftcardsListWrapper = lazy(() => import('../pages/payments/giftcards/list/GiftcardsList'))
  // const OtherPaymentsListWrapper = lazy(
  //   () => import('../pages/payments/other-payments/list/OtherPaymentsList')
  // )
  const NotificationsPage = lazy(() => import('../pages/notifications/NotificationsPage'))
  const TemplatesPage = lazy(() => import('../pages/email-templates/TemplatesPage'))
  const PollsPage = lazy(() => import('../pages/polls/PollsPage'))
  const EditingPage = lazy(() => import('../pages/settings/editing-page/EditingPage'))
  const OrdersPage = lazy(() => import('../pages/orders/OrdersPage'))
  const TracksPage = lazy(() => import('../pages/tracks/TracksPage'))
  const ShipmentsPage = lazy(() => import('../pages/shipments/ShipmentsPage'))
  const ParcelsPage = lazy(() => import('../pages/parcels/ParcelsPage'))
  const TTNsPage = lazy(() => import('../pages/ttns/TTNsPage'))
  const AcceptTracksPage = lazy(() => import('../pages/tracks-accept/AcceptTracksPage'))
  const FinancesPage = lazy(() => import('../pages/finances/FinancesPage'))
  const DirectionsPage = lazy(() => import('../pages/directions/DirectionsPage'))
  const CountriesPage = lazy(() => import('../pages/countries/CountriesPage'))
  const CouriersPage = lazy(() => import('../pages/couriers/CouriersPage'))
  const RegionsPage = lazy(() => import('../pages/regions/RegionsPage'))
  const LocationsPage = lazy(() => import('../pages/locations/LocationsPage'))
  const DeliveryTypesPage = lazy(() => import('../pages/delivery-types/DeliveryTypesPage'))
  const WarehousesPage = lazy(() => import('../pages/warehouses/WarehousesPage'))
  const TranslationsPage = lazy(() => import('../pages/translations/TranslationsPage'))
  const UserGroupsPage = lazy(() => import('../pages/user-groups/UserGroupsPage'))
  const EmployeesPage = lazy(() => import('../pages/employees/EmployeesPage'))
  const UsersPage = lazy(() => import('../pages/users/UsersPage'))
  const FulfReceiversPage = lazy(() => import('../pages/fulfillment/receivers/FulfReceiversPage'))
  const ReceiveShipmentWrapper = lazy(() => import('../pages/fulfillment/accept-and-unpack/accept/ReceiveShipmentPage'))
  const UnpackShipmentWrapper = lazy(() => import('../pages/fulfillment/accept-and-unpack/unpack/UnpackShipmentPage'))
  const GoodsPage = lazy(() => import('../pages/fulfillment/goods/GoodsPage'))
  const WebsitesWrapper = lazy(() => import('../pages/websites/WebsitesWrapper'))
  const WebsitePage = lazy(() => import('../pages/websites/website-page/WebsitePage'))
  const TranslationBoardPage = lazy(() => import('../pages/websites/elements/TranslationBoard/TranslationBoardPage'))
  const WebsitePages = lazy(() => import('../pages/website-pages/WebsitePages'))
  const WebsiteForms = lazy(() => import('../pages/website-forms/WebsiteForms'))
  const ArticlesPage = lazy(() => import('../pages/blog/ArticlesPage'))
  const StoresPage = lazy(() => import('../pages/stores/StoresPage'))
  const SGoodsPage = lazy(() => import('../pages/store-goods/SGoodsPage'))
  const BlogCategoriesPage = lazy(() => import('../pages/categories/blog/BlogCategoriesPage'))
  const StoresCategoriesPage = lazy(() => import('../pages/categories/stores/StoresCategoriesPage'))
  const StoresCollectionsPage = lazy(() => import('../pages/collections/stores/StoresCollectionsPage'))
  const ChatsPage = lazy(() => import('../pages/chats/ChatsPage'))
  const ListsPage = lazy(() => import('../pages/lists/ListsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registration */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route
          path='email-templates/*'
          element={
            <SuspensedView>
              <TemplatesPage />
            </SuspensedView>
          }
        />
        <Route
          path='notifications/*'
          element={
            <SuspensedView>
              <NotificationsPage />
            </SuspensedView>
          }
        />
        <Route
          path='polls/*'
          element={
            <SuspensedView>
              <PollsPage />
            </SuspensedView>
          }
        />
        <Route
          path='settings/edit/*'
          element={
            <SuspensedView>
              <EditingPage />
            </SuspensedView>
          }
        />
        {/* ----------------------- */}
        {/* BUYOUTS */}
        <Route
          path='buyouts/*'
          element={
            <SuspensedView>
              <OrdersPage />{' '}
            </SuspensedView>
          }
        />
        <Route
          path='buyouts/create'
          element={
            <Navigate
              to={`/buyouts/list`}
              state={{
                create: true,
              }}
            />
          }
        />
        {/* ----------------------- */}
        {/* TRACKS, ORDERS, SHIPMENTS, PARCELS */}
        <Route
          path='tracks/*'
          element={
            <SuspensedView>
              <TracksPage />{' '}
            </SuspensedView>
          }
        />
        <Route
          path='orders/*'
          element={
            <SuspensedView>
              <OrdersPage />{' '}
            </SuspensedView>
          }
        />
        <Route
          path='shipments/*'
          element={
            <SuspensedView>
              <ShipmentsPage />
            </SuspensedView>
          }
        />
        <Route
          path='parcels/*'
          element={
            <SuspensedView>
              <ParcelsPage />
            </SuspensedView>
          }
        />
        <Route
          path='ttns/*'
          element={
            <SuspensedView>
              <TTNsPage />
            </SuspensedView>
          }
        />
        <Route
          path='accept-tracks/*'
          element={
            <SuspensedView>
              <AcceptTracksPage />
            </SuspensedView>
          }
        />
        {/* ----------------------- */}
        {/* FINANCES */}
        <Route
          path='finances/*'
          element={
            <SuspensedView>
              <FinancesPage />
            </SuspensedView>
          }
        />

        {/* ----------------------- */}
        {/* LOGISTICS */}
        <Route
          path='directions/*'
          element={
            <SuspensedView>
              <DirectionsPage />
            </SuspensedView>
          }
        />
        <Route
          path='states/*'
          element={
            <SuspensedView>
              <CountriesPage />
            </SuspensedView>
          }
        />
        <Route
          path='couriers/*'
          element={
            <SuspensedView>
              <CouriersPage />
            </SuspensedView>
          }
        />
        <Route
          path='areas/*'
          element={
            <SuspensedView>
              <RegionsPage />
            </SuspensedView>
          }
        />
        <Route
          path='locations/*'
          element={
            <SuspensedView>
              <LocationsPage />
            </SuspensedView>
          }
        />
        <Route
          path='delivery-types/*'
          element={
            <SuspensedView>
              <DeliveryTypesPage />
            </SuspensedView>
          }
        />
        <Route
          path='warehouses/*'
          element={
            <SuspensedView>
              <WarehousesPage />
            </SuspensedView>
          }
        />
        <Route
          path='translations/*'
          element={
            <SuspensedView>
              <TranslationsPage />
            </SuspensedView>
          }
        />
        {/* ----------------------- */}
        {/* USERS */}
        <Route
          path='user-groups/*'
          element={
            <SuspensedView>
              <UserGroupsPage />
            </SuspensedView>
          }
        />
        <Route
          path='employees/*'
          element={
            <SuspensedView>
              <EmployeesPage />
            </SuspensedView>
          }
        />
        <Route
          path='users/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        <Route
          path='receivers/*'
          element={
            <SuspensedView>
              <FulfReceiversPage />
            </SuspensedView>
          }
        />
        {/* ----------------------- */}
        {/* FULFILMENT */}
        <Route
          path='fulfillment/accept'
          element={
            <SuspensedView>
              <ReceiveShipmentWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='fulfillment/unpack'
          element={
            <SuspensedView>
              <UnpackShipmentWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='fulfillment/goods/*'
          element={
            <SuspensedView>
              <GoodsPage />
            </SuspensedView>
          }
        />
        {/* ----------------------- */}
        {/* WEBSITES */}
        <Route
          path='websites'
          element={
            <SuspensedView>
              <WebsitesWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='websites/edit/:id/*'
          element={
            <SuspensedView>
              <WebsitePage />
            </SuspensedView>
          }
        />
        <Route
          path='websites/translation/:id/*'
          element={
            <SuspensedView>
              <TranslationBoardPage />
            </SuspensedView>
          }
        />
        <Route
          path='websites/pages/*'
          element={
            <SuspensedView>
              <WebsitePages />
            </SuspensedView>
          }
        />
        {/* Lazy Modules */}
        <Route
          path='websites/forms/*'
          element={
            <SuspensedView>
              <WebsiteForms />
            </SuspensedView>
          }
        />
        {/* Lazy Modules End*/}
        {/* dynamic pages */}
        <Route
          path='blog/*'
          element={
            <SuspensedView>
              <ArticlesPage />{' '}
            </SuspensedView>
          }
        />
        <Route
          path='stores/*'
          element={
            <SuspensedView>
              <StoresPage />{' '}
            </SuspensedView>
          }
        />
        <Route
          path='sgoods/*'
          element={
            <SuspensedView>
              <SGoodsPage />{' '}
            </SuspensedView>
          }
        />
        <Route
          path='website-categories/blog/*'
          element={
            <SuspensedView>
              <BlogCategoriesPage />{' '}
            </SuspensedView>
          }
        />
        <Route
          path='website-categories/stores/*'
          element={
            <SuspensedView>
              <StoresCategoriesPage />{' '}
            </SuspensedView>
          }
        />
        <Route
          path='website-collections/stores/*'
          element={
            <SuspensedView>
              <StoresCollectionsPage />{' '}
            </SuspensedView>
          }
        />
        {/* ----------------------- */}
        {/* PAYMENTS */}
        {/* giftcards */}
        {/* <Route
          path='giftcards/list'
          element={
            <SuspensedView>
              <PageTitle>Список гифт-карт</PageTitle>

              <GiftcardsListWrapper empty={false} />
            </SuspensedView>
          }
        />
        <Route path='giftcards/add' element={<SuspensedView>add MAKE LAZY LOAD</SuspensedView>} />
        <Route
          path='giftcards/empty'
          element={
            <SuspensedView>
              <PageTitle>Список пустых гифт-карт</PageTitle>
              <GiftcardsListWrapper empty={true} />
            </SuspensedView>
          }
        /> */}
        {/* other payments */}
        {/* <Route
          path='other-payments/list'
          element={
            <SuspensedView>
              <PageTitle>Список других способов оплаты</PageTitle>
              <OtherPaymentsListWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='other-payments/add'
          element={<SuspensedView>add payment MAKE LAZY LOAD</SuspensedView>}
        /> */}
        {/* ----------------------- */}
        {/* MSCLNS */}
        <Route
          path='chats/*'
          element={
            <SuspensedView>
              <ChatsPage />
            </SuspensedView>
          }
        />
        <Route
          path='lists/*'
          element={
            <SuspensedView>
              <ListsPage />
            </SuspensedView>
          }
        />
        {/* ----------------------- */}
        {/* ORIGINAL */}
        {/* <Route path='menu-test' element={<MenuTestPage />} /> */}
        {/*<Route path='builder' element={<BuilderPageWrapper />} />*/}
        {/*<Route*/}
        {/*  path='crafted/pages/wizards/*'*/}
        {/*  element={*/}
        {/*    <SuspensedView>*/}
        {/*      <WizardsPage />*/}
        {/*    </SuspensedView>*/}
        {/*  }*/}
        {/*/>*/}
        {/*<Route*/}
        {/*  path='crafted/widgets/*'*/}
        {/*  element={*/}
        {/*    <SuspensedView>*/}
        {/*      <WidgetsPage />*/}
        {/*    </SuspensedView>*/}
        {/*  }*/}
        {/*/>*/}
        <Route
          path='account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        {/*<Route*/}
        {/*  path='apps/chat/*'*/}
        {/*  element={*/}
        {/*    <SuspensedView>*/}
        {/*      <ChatPage />*/}
        {/*    </SuspensedView>*/}
        {/*  }*/}
        {/*/>*/}
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--kt-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
